module.exports = __webpack_public_path__ + "img/subjectlogo.d587bc66.svg";